module.exports = __webpack_public_path__ + "img/logo_tropigas-_rd.43142588.png";